import ajax from '../utils/ajaxHelper';

// communityService.js (suggested new file)
export const getHealthFacilityTypes = async (val) => {
  try {
    return await ajax.post(`community/get-health-facility-types`, val);
  } catch (error) {
    return error;
  }
};
export const getAmenityCategories = async (val) => {
  try {
    return await ajax.post(`community/get-amenity-categories`, val);
  } catch (error) {
    return error;
  }
};
export const updateAmenityData = async (val) => {
  try {
    return await ajax.post(`import/update-amenity-data`, val);
  } catch (error) {
    return error;
  }
};
